type Status = 'REAL' | 'MOCK' | 'DEFERRED' | 'BLOCKED';

interface Props {
  title: string;
  status: Status;
  description: string;
}

/** Mirrors the placeholder card in web-preview/index.html — kept visually
 * consistent so migration is a drop-in swap, not a redesign.
 * VISUAL SYSTEM (2026-08-16): retrofitted to `--alex-*` design tokens. */
export default function ModulePlaceholder({ title, status, description }: Props) {
  return (
    <div style={{ padding: 'var(--alex-content-padding)', fontFamily: 'var(--alex-font-family)' }}>
      <h1 style={{ fontSize: 'var(--alex-fs-page-title)', fontWeight: 'var(--alex-fw-page-title)' as unknown as number, color: 'var(--alex-text-primary)' }}>
        {title}
      </h1>
      <p style={{ color: 'var(--alex-text-secondary)', fontSize: 'var(--alex-fs-body)' }}>
        [{status}] {description}
      </p>
    </div>
  );
}
